/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
// import { Avatar } from "@material-ui/core";
import React, { useEffect } from "react";
import classNames from "classnames";
// import useStoreArchem from "src/storeArchem";
// import useStoreArchem from "host/storeArchem";
import { When } from "react-if";
// import { useLocation } from "react-router-dom";
import { NavLink, useLocation } from "react-router-dom";
import useStoreArchem from "src/storeArchem";
import { shallow } from 'zustand/shallow';

import { checkExactIsActive, checkIsActive } from "@helpers/RouterHelpers";

// import SVG from "react-inlinesvg";
// import { checkExactIsActive, checkIsActive } from "../../../../_helpers";
import { useGetUserRolesAndAllowedApplication, useGetUserRolesForApplication } from './../../../../../app/_apiUserRoles';
// import { useSessionStorageString } from "react-use-window-sessionstorage";
// import SessionKeystore from 'session-keystore';
// // import { useSubheader } from "../../_buildportal/layout";
import useStoreCurrentUserRoles from './../../../../../app/_storeUsersCurrentRoles';

// const store = new SessionKeystore();

const getState = state => ({ setCurrentRoles: state.setCurrentRoles, currentRoles: state.currentRoles, setAllowedApps: state.setAllowedApps });

export function AsideMenuList({ layoutProps }) {

  const _storeCurrentRoles = useStoreCurrentUserRoles(getState, shallow);
  const _apiUserRoles = useGetUserRolesForApplication();
  const _apiAllowedApplications = useGetUserRolesAndAllowedApplication()
  const resetAsideMenu = useStoreArchem(state => state.resetAsideMenu);
  const location = useLocation();
  // console.log('aside location: ', location)

  useEffect(() => {
    // console.log(_apiUserRoles.data);
    if (_apiUserRoles.data) {
      _storeCurrentRoles.setCurrentRoles(_apiUserRoles.data);
    }
  }, [_apiUserRoles.data]);

  useEffect(() => {
    if (_apiAllowedApplications.data) {
      _storeCurrentRoles.setAllowedApps(_apiAllowedApplications.data.allowed_apps);
    }
  }, [_apiAllowedApplications.data]);

  useEffect(() => {
    if (_apiUserRoles.isLoading || _apiUserRoles.isFetching) {
      _storeCurrentRoles.setCurrentRoles('');
    }
  }, [_apiUserRoles.isLoading, _apiUserRoles.isFetching]);

  const getMenuItemActive = (url, hasSubmenu = false, exactMenu = false) => {
    // console.log(location);            
    if (!exactMenu) {
      return checkIsActive(location, url)
        ? ` ${!hasSubmenu &&
        "menu-item-active"} menu-item-open menu-item-not-hightlighted`
        : "";
    } else {
      return checkExactIsActive(location, url)
        ? ` ${!hasSubmenu &&
        "menu-item-active"} menu-item-open menu-item-not-hightlighted`
        : "";
    }
  };

  const _asideMenu = useStoreArchem(state => state.asideMenu);

  const findCommonElements = (arr1, arr2) => {
    return arr1.some(item => arr2.includes(item))
  }


  const CreateMenu = (menus) => {
    // console.log(menus)
    return (
      menus.map((menu, idx) => {
        const isAllowed = menu.hasOwnProperty('isAllowed') ? (menu.isAllowed || false) : true;

        if (!isAllowed) {
          return '';
        } else {
          return (
            <li
              className={`${classNames("menu-item", { "menu-item-submenu": menu.hasSubMenu || false })} ${getMenuItemActive(menu.url, false, (menu.exactMenu || false))} `}
              aria-haspopup="true"
              key={`${menu.name}-${idx}`}
            >
              <NavLink className={classNames("menu-link", { "menu-toggle": menu.hasSubMenu || false })} to={menu.url}>
                <i className={`${menu.icon} menu-icon icon-xl menu-icon-style`} ></i>
                <span className="menu-text notabsolute menu-custom-text">{menu.name}</span>
                {(menu.hasSubMenu || false) && <i className="menu-arrow" />}
              </NavLink>

              {(menu.hasSubMenu || false) && <>
                <div className="menu-submenu">
                  <i className="menu-arrow" />
                  <ul className="menu-subnav">
                    <li className="menu-item menu-item-parent" aria-haspopup="true">
                      <span className="menu-link">
                        <span className="menu-text">{menu.name}</span>
                      </span>
                    </li>

                    {menu.submenu.map((subMenu, idx2) => {
                      const isSubMenuAllowed = subMenu.hasOwnProperty('isAllowed') ? (subMenu.isAllowed || false) : true;
                      if (!isSubMenuAllowed) return '';

                      return (
                        <li key={`${subMenu.name}-${idx2}`} className={classNames("menu-item", { "menu-item-submenu": (subMenu.hasSubMenu || false) })} aria-haspopup="true" data-menu-toggle="hover">
                          <NavLink className={classNames("menu-link", { "menu-toggle": subMenu.hasSubMenu || false })} to={subMenu.url}>
                            <i className="menu-bullet menu-bullet-dot">
                              <span></span>
                            </i>
                            <span className="menu-text">{subMenu.name}</span>
                            {(subMenu.hasSubMenu || false) && <i className="menu-arrow"></i>}
                          </NavLink>
                          {
                            subMenu.hasSubMenu &&
                            <div className="menu-submenu">
                              <i className="menu-arrow"></i>
                              <ul className="menu-subnav">
                                {
                                  subMenu.submenu.map((subMenu2nd, idx3) =>
                                    <li key={`${subMenu2nd.name}-${idx3}`} className="menu-item" aria-haspopup="true">
                                      <NavLink className="menu-link" to={subMenu2nd.url}>
                                        <i className="menu-bullet menu-bullet-dot">
                                          <span></span>
                                        </i>
                                        <span className="menu-text">{subMenu2nd.name}</span>
                                      </NavLink>
                                    </li>
                                  )
                                }
                              </ul>
                            </div>
                          }
                        </li>
                      )
                    })}
                  </ul>
                </div>

              </>}

            </li>
          )
        }
      })
    )
  }

  const GenerateSubMenu = (mnuIndex, logisticsMenu, _currentUserRoles) => {
    return (
      <div className="menu-submenu " key={mnuIndex + '-5'}>
        <ul className="menu-subnav" key={mnuIndex + '-6'}>
          <ul className="menu-subnav" key={mnuIndex + '-7'}>
            <li className="menu-item  menu-item-parent" aria-haspopup="true" key={mnuIndex + '-8'}>
              <span className="menu-link notabsolute" key={mnuIndex + '-9'}>
                <span className="menu-text notabsolute" key={mnuIndex + '-10'}>{logisticsMenu.name}</span>
              </span>
            </li>
            {
              logisticsMenu.submenu.map((logisticsSubMenu, subMnuIndex) => {
                if (findCommonElements(logisticsSubMenu.permissions, _currentUserRoles) || logisticsSubMenu.alloweveryone) {
                  if (!(logisticsSubMenu.hasSubMenu || false)) {
                    return <li className={`menu-item ${getMenuItemActive(logisticsSubMenu.url)}`} aria-haspopup="true" key={mnuIndex + '-' + subMnuIndex + '-0'}>
                      <NavLink className="menu-link" to={logisticsSubMenu.url} key={mnuIndex + '-' + subMnuIndex + '-1'}>
                        <i className="menu-bullet menu-bullet-dot" key={mnuIndex + '-' + subMnuIndex + '-2'}>
                          <span className="notabsolute" key={mnuIndex + '-' + subMnuIndex + '-3'} />
                        </i>
                        <span className="menu-text notabsolute" key={mnuIndex + '-' + subMnuIndex + '-4'}>{logisticsSubMenu.name}</span>
                      </NavLink>
                    </li>;
                  } else {
                    return GenerateMenu(logisticsMenu.submenu, _currentUserRoles);
                  }
                } else {
                  return '';
                }
              })
            }
          </ul>
        </ul>
      </div>
    )
  }


  const GenerateMenu = (appMenu, _currentUserRoles) => {
    return appMenu.map((logisticsMenu, mnuIndex) => {
      if (!logisticsMenu.hasSubMenu && (findCommonElements(logisticsMenu.permissions, _currentUserRoles) || logisticsMenu.alloweveryone)) {
        return <li className={`menu-item ${getMenuItemActive(logisticsMenu.url, false, (logisticsMenu.exactMenu || false))}`} aria-haspopup="true" key={mnuIndex + '--0'} >
          <NavLink className="menu-link" to={logisticsMenu.url} key={mnuIndex + '--1'}>
            <i className={`${logisticsMenu.icon} menu-icon icon-xl menu-icon-style`} key={mnuIndex + '--2'}></i>
            <span className="menu-text notabsolute menu-custom-text" key={mnuIndex + '--3'}>{logisticsMenu.name}</span>
          </NavLink>
        </li>;
      }
      else if (findCommonElements(logisticsMenu.permissions, _currentUserRoles)) {
        return <li className={`menu-item menu-item-submenu ${getMenuItemActive(logisticsMenu.url, true)}`} aria-haspopup="true" data-menu-toggle="hover" key={mnuIndex + '-0'}>
          <NavLink className="menu-link menu-toggle" to={logisticsMenu.url} key={mnuIndex + '-1'}>
            <i className={`${logisticsMenu.icon} menu-icon icon-lg menu-icon-style`} key={mnuIndex + '-2'}></i>
            <span className="menu-text notabsolute menu-custom-text" key={mnuIndex + '-3'}>{logisticsMenu.name}</span>
            <i className="menu-arrow" key={mnuIndex + '-4'} />
          </NavLink>
          {
            GenerateSubMenu(mnuIndex, logisticsMenu, _currentUserRoles)
          }
        </li>;
      } else {
        return '';
      }
    });
  }

  const onClickHome = () => {
    resetAsideMenu();
  }

  // console.log(ability.can('settings_drivers', 'Settings'))
  return (
    <>
      {/* begin::Menu Nav onClick={() => { console.log('push history'); history.push('/home') }}*/}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li className={`menu-item ${getMenuItemActive("/home", false)}`} aria-haspopup="true">
          <NavLink className="menu-link" onClick={onClickHome} to="/home" >
            <i className="flaticon-squares-4 menu-icon icon-xl menu-icon-style"></i>
            <span className="menu-text notabsolute menu-custom-text">Applications</span>
          </NavLink>
        </li>

        <When condition={_asideMenu !== undefined && _asideMenu !== null && Array.isArray(_asideMenu) && _asideMenu.length > 0}>
          {CreateMenu(_asideMenu)}
        </When>
        {/* <li className={`menu-item ${getMenuItemActive("/logout", false)}`} aria-haspopup="true" >
          <NavLink className="menu-link" to="/logout">
            <i className="bi-power menu-icon icon-xl menu-icon-style"></i>
            <span className="menu-text notabsolute menu-custom-text">Logout</span>
          </NavLink>
        </li> */}
      </ul>
    </>
  );
}

